import { render, staticRenderFns } from "./SettingsTaxRateForm.vue?vue&type=template&id=95c44570&"
import script from "./SettingsTaxRateForm.vue?vue&type=script&lang=js&"
export * from "./SettingsTaxRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports